// ADD all api endpoints here
export const API_ENDPOINTS = {
    STORE_USER : "/user/guest/store",
    GET_EVENT : "/event/",
    CHECK_USER_EXISTS : "/user/guest/exist",
    USER_NOTE : "/user/guest/note/store",
    GET_NOTES : "/user/guest/notes",
};
